import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { ClientSpecificInfoModel } from "app/support/models/client_specific_info.model";
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root',
})

export class OrganizationUnitService extends GenericService<ClientSpecificInfoModel> {
    constructor(private http: HttpClient) {
        super(http,'/api/OrganizationUnit/GetClients', environment.Services.MasterDataURL)
    }
}